module.exports = __webpack_public_path__ + "img/cases_8.44ea4c96.png";